<template>
  <resource-base
    :ref="resourceBaseRef"
    :loading-display="false"
    :is-management-mode="isManagementMode"
    :display-activity="myAppSettings_isDisplayActivity"
    :display-settings="myAppSettings_isDisplaySettings"
    :resource="resource"
    :settings="settings"
    @settings-gen-changed="handleSettingsGenChange"
    @update-settings="handleUpdateSettings"
  >
    <template v-slot:display>
      <div>
      <b-container style="margin-top: 50px;">
        <display
            style="margin-bottom: 50px;"
            :is-demo="isDemo"
            :path-publishing="pathPublishing"
            :resource="resource"
            :settings="settings"
            @appLog="appLog"
            @user-clicked-about="handleUserClickedAbout"
        />
      </b-container>
      </div>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" :settings="settings" />
    </template>
    <template v-slot:settings>
      <settings
        :resource="resource"
        :settings="settings"
        @resource-updated="handleRefreshResource"
        @settings-user-changed="handleSettingsUserChange"
      />
    </template>
  </resource-base>
</template>

<script>
import ResourceBase from "../resourceBase"; //Can Possibly do something with paths and place in mixin
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
import ResourceBlockIndex from "@/mixins/resourceBlocks/Index";
export default {
  name: "Resource_DearWords",
  mixins: [ResourceBlockIndex],
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  props: {
    isDemo: {
      type: Boolean,
      default: false
    },
    pathPublishing: {
      type: String,
      default: null
    },
  },
  created() {
    this.handleSetUp();
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}
</style>
